export enum NodeVisualState {
  Default = 'default',
  Passed = 'passed',
  Active = 'active',
}
